import React from 'react';
import styled from 'styled-components';


export const BoxContainer = styled.div`
    width:100%;
    margin-top:2px;
    margin-bottom:2px;    

`
export const Container = styled.div`
    display:flex;
    flex-direction:row;
    align-items:flex-start;
    justify-content:flex-start;
    width:100%;
    height:auto;
    cursor:pointer;
`

export const CheckBox = styled.div`
    position:relative;
    width:17px;
    height:17px;
    margin-top:1px;
    margin-right:7px;

    overflow:hidden;

    border:2px solid ${props => props.checked ?  '#000FFF!important' : '#dbdbdb'};
    border-radius:3px;
    background: ${props => props.checked ?  '#000FFF!important' : '#ffffff'};
    transition:all 75ms ease;
    cursor:pointer;
`
export const Check = styled.label`
    position:absolute;
    display:block;
    float:none;

    top:-2px; left:0;

    width:100%;
    height:auto;
    line-height:17px;
    font-size:12px;
    color:#ffffff;

    text-align:center;
    
    transition:all 25ms ease;
    opacity: ${props => props.checked ?  '1' : '0'};
`

export const Label = styled.label`
    width:calc(100% - 22px);
    height:auto;
    line-height:1rem;
    font-size:.9rem;
    color:#707070;
    cursor:pointer;
`

export default function CheckBoxCustom({ name, label, title, checked, onChange }) {
    return(
        <BoxContainer onClick={onChange} title={title}>
            <Container>
                <CheckBox checked={checked}>
                    <Check checked={checked}>✔</Check>
                </CheckBox>
                <Label>{label}</Label>
            </Container>
        </BoxContainer>
    );
}